import menuWarehouse from '../../../../api/menuWarehouse';

const defaultState = () => ({
	listMenu: []
});

const state = defaultState();

const getters = {

};

const mutations = {
	setMenu(state, data) {
		state.listMenu = data
	}
};

const actions = {
	getMenu({ dispatch, commit }) {
		menuWarehouse.getMenu().then(({ data: { data } }) => {
			commit('setMenu', data.results);
		}).catch((err) => {
			commit('setMenu', { data: [] });
			const { data } = err.response;
			dispatch('errorHandler', data);
		});
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};